import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusBuildings = (props) => {
    const width = props.width ? props.width + 'px' : '68px';
    const height = props.height ? props.height + 'px' : '36px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 68 36"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M30.5911 5.91406H27.498V9.01792H30.5911V5.91406Z" />
            <path d="M24.4524 5.91406H21.3594V9.01792H24.4524V5.91406Z" />
            <path d="M18.3118 5.91406H15.2188V9.01792H18.3118V5.91406Z" />
            <path d="M30.5911 11.6006H27.498V14.7044H30.5911V11.6006Z" />
            <path d="M24.4524 11.6006H21.3594V14.7044H24.4524V11.6006Z" />
            <path d="M18.3118 11.6006H15.2188V14.7044H18.3118V11.6006Z" />
            <path d="M30.5911 17.2866H27.498V20.3905H30.5911V17.2866Z" />
            <path d="M24.4524 17.2866H21.3594V20.3905H24.4524V17.2866Z" />
            <path d="M18.3118 17.2866H15.2188V20.3905H18.3118V17.2866Z" />
            <path d="M54.9661 17.2866H51.873V20.3905H54.9661V17.2866Z" />
            <path d="M48.8274 17.2866H45.7344V20.3905H48.8274V17.2866Z" />
            <path d="M42.6888 17.2866H39.5957V20.3905H42.6888V17.2866Z" />
            <path d="M36.6201 29.4179H61.0481V27.3992H61.0292V12.3064H61.0481V11.3397H36.6012V3.10386H36.6201V0H28.7009H17.5801H9.08008V29.4179H36.6201ZM57.9362 14.709V26.3093H36.6012V14.709H57.9362ZM27.4967 26.3093V22.5847H18.312V26.3093H12.1731V3.10386H33.5081V26.3093H27.4967Z" />
            <path d="M68 32.3037H0V35.9999H68V32.3037Z" />
        </SvgStyled>
    );
};

export default CampusBuildings;
